import type { ComponentType } from 'react';

import { ROUTES } from '@/shared/constants/routes';

export const ROUTE_PREFETCH_MAP: Record<string, () => Promise<{ default: ComponentType }>> = {
  [ROUTES.DATASET]: () => import('@/view/screens/DataSourcePage/DataSourcePage.view'),
  [ROUTES.DATA_STUDIO]: () => import('@/view/screens/DataStudio/DataStudio.view'),
  [ROUTES.DASHBOARDS]: () => import('@/view/screens/DashboardPage/DashboardPage.view'),
  [ROUTES.PRESENTATIONS]: () => import('@/view/screens/PresentationsPage/PresentationsPage.view'),
  [ROUTES.DOCUMENTS]: () => import('@/view/screens/PresentationsPage/PresentationsPage.view'),
  [ROUTES.VIDEOS]: () => import('@/view/screens/PresentationsPage/PresentationsPage.view'),
  [ROUTES.KNOWLEDGE]: () => import('@/view/screens/KnowledgePage/KnowledgePage.view'),
  [ROUTES.SCHEDULER]: () => import('@/view/screens/CronSchedulerPage/CronSchedulerPage.view'),
  [ROUTES.ALERTS]: () => import('@/view/screens/AlertsPage/AlertsPage.view'),
  [ROUTES.REPORTS]: () => import('@/view/screens/ReportsPage/ReportsPage.view'),
  [ROUTES.DATA_SHARES]: () => import('@/view/screens/DataSharesPage/DataSharesPage.view'),
  [ROUTES.DATA_EGRESS]: () => import('@/view/screens/DataEgressPage/DataEgressPage.view'),
  [ROUTES.MCP]: () => import('@/view/screens/McpPage/McpPage.view'),
  [ROUTES.BILLING]: () => import('@/view/screens/BillingPage/BillingPage.view'),
  [ROUTES.AUDIT_LOGS]: () => import('@/view/screens/AuditLogsPage/AuditLogsPage.view'),
  [ROUTES.CREDITS]: () => import('@/view/screens/CreditsPage/CreditsPage.view'),
  [ROUTES.PRIVATE_CONNECTIONS]: () =>
    import('@/view/screens/PrivateConnectionsPage/PrivateConnectionsPage.view'),
};
